import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation("home");

  return (
    <section className="flex flex-col md:flex-row min-h-[500px] md:h-[600px]">
      <div className="relative w-full md:w-1/2 h-[300px] md:h-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20European%20urban%20fashion%20lifestyle%20photography%2C%20warm%20neutral%20beige%20and%20cream%20tones%2C%20soft%20natural%20daylight%2C%20casual%20elegant%20outfit%20on%20clean%20city%20backdrop%2C%20editorial%20quality%2C%20minimalist%20composition%2C%20airy%20atmosphere%2C%20effortless%20style&width=900&height=700&seq=cta-split-v2-001&orientation=portrait"
          alt="USFansSpreadsheet Fashion"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        <div className="absolute top-6 left-6">
          <span className="text-xs text-foreground-700 bg-background-50/90 backdrop-blur-sm px-3 py-1.5 rounded-full font-medium">
            {t("ctaShopLabel")}
          </span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-white leading-[1.1]">
            {t("ctaShopTitle1")}
            <br />
            {t("ctaShopTitle2")}
            <br />
            <span className="text-accent-300">{t("ctaShopTitle3")}</span>
          </h2>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center w-full md:w-1/2 bg-background-50 px-6 md:px-12 py-12 md:py-0">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            {t("ctaBuyTitle1")}
            <br />
            {t("ctaBuyTitle2")}
          </h2>
          <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("ctaBuyDesc")}
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 mt-8 bg-foreground-950 text-white px-8 py-4 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            {t("buyItNow", { ns: "common" })}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}